import { useState } from "react";
import { Button, Form } from "react-bootstrap"
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, } from "@mui/material"
import { onSubmitEditPrecioUnidad, preciounidadSchema } from "./handlers"
import TextInput from "../../components/ReactHookForm/TextInput";
import ContainedMuniSpinner from "../../components/MuniSpinner/ContainedMuniSpinner";



export const FormCambiarPrecioUnidad = (props) => {
  const { setPrecioUnidad, setCambiarPrecioUnidadModalIsOpenIsOpen } = props
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, formState: { errors }, } = useForm({
    resolver: yupResolver(preciounidadSchema)
  })

  return (
    <Box>
      <Form onSubmit={handleSubmit((data) => onSubmitEditPrecioUnidad(data, setPrecioUnidad, setIsLoading, setCambiarPrecioUnidadModalIsOpenIsOpen))}>
        <fieldset disabled={isLoading} >
          <Box className="d-flex gap-4 mt-2">
            <TextInput name='precio_unidad' label='Nuevo Precio *' register={register} errors={errors?.precio_unidad} />
            <Button type="submit" className="" disabled={isLoading} style={{ height: '38px', marginTop: '32px', alignSelf: 'flex-middle' }}>
              {isLoading ?
                <Box className="w-full h-full">
                  <ContainedMuniSpinner height={25} width={25} size={35} />
                </Box>
                : 'Guardar'}
            </Button>
          </Box>
        </fieldset>
      </Form>
    </Box>
  )
}

export default FormCambiarPrecioUnidad  